import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/pavelmaxim/Code/Tannenboden/tannenboden-website/src/app/[lang]/trail-discovery/TrailDiscoveryContent.tsx");
